exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:block;margin-top:1rem}:host jhi-fiche-acteur{margin-bottom:1rem}:host jhi-button{float:right}:host .fa{margin-right:1rem}:host ul{list-style-type:none;padding-inline-start:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/requerants/add-requerant-section/result-form/result-form.component.scss
// module id = 679
// module chunks = 0